import { mapGetters, mapActions } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
function onStateChange(event) {
    let currentId = event.target.getIframe().id;
    let currentPlayer = window.players[currentId];
    for (let key in window.players) {
        let item = window.players[key];
        if (key !== currentId && item && item.getPlayerState() === window.YT.PlayerState.PLAYING) {
            item.pauseVideo();
        }
    }
    document.getElementById(currentId).parentNode.dataset.state = currentPlayer.getPlayerState();
    if (currentPlayer.getPlayerState() === window.YT.PlayerState.UNSTARTED) {
        $(document).trigger(`video.play`, { iframe: event.target.getIframe() });
    }
}
function onPlayerReady() {
    if (!window.players) {
        window.players = {};
        let tag = document.createElement('script');
        tag.src = `https://www.youtube.com/iframe_api`;
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = function () {
            let iframes = document.querySelectorAll('.mvt-nearbyvideo .video');
            iframes.forEach((iframe) => {
                if (iframe.dataset.load) {
                    return;
                }
                iframe.dataset.load = true;
                let elementId = iframe.id;
                let videoId = iframe.dataset.id;
                window.players[elementId] = new window.YT.Player(elementId, {
                    videoId: videoId,
                    playerVars: {
                        controls: 0,
                        disablekb: 1,
                        rel: 0,
                    },
                    events: {
                        onStateChange: onStateChange,
                    },
                });
            });
        };
    }
}
export default {
    name: 'mvtNearbyvideo',
    components: {
        mvtShifter,
    },
    inject: ['$eventBus'],
    data() {
        return {
            initialed: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getVideos']),
        getKeywords() {
            return [`${this.getGeoSearchText} tour`, `things to do in ${this.getGeoSearchText}`, `best places to live ${this.getGeoSearchText}`];
        },
        getGeoSearchText() {
            let geo = this.glb.geo;
            if (geo.address) {
                return `${geo.address}, ${geo.city}, ${geo.state}`;
            } else if (geo.neighborhood) {
                return `${geo.neighborhood}, ${geo.city}, ${geo.state}`;
            } else if (geo.zipcode) {
                return `${geo.zipcode}, ${geo.state}`;
            } else if (geo.city) {
                return `${geo.city}, ${geo.state}`;
            } else if (geo.county) {
                return `${geo.county}, ${geo.state}`;
            } else if (geo.state) {
                return `${geo.state}`;
            }
            return '';
        },
    },
    methods: {
        ...mapActions('glb', ['searchVideoByKeywords', 'searchVideoByIds']),
        sendTrack(iframe) {
            let videoId = iframe.dataset.id;
            let index = iframe.dataset.index;
            const el = ['tour', 'things_to_do', 'best_places_to_live'];
            this.$eventBus.$emit(
                'ga4',
                { en: 'click_custom', ec: 'video', el: el[index] },
                {
                    eventData: {
                        trigger: videoId,
                        link_name: this.getKeywords[index],
                    },
                }
            );
        },
    },
    watch: {
        getVideos(newVal) {
            if (newVal && newVal.length > 0) {
                this.$nextTick(() => {
                    if (this.initialed) return;
                    onPlayerReady();
                    this.initialed = true;
                });
            }
        },
    },
    mounted() {
        let observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.searchVideoByKeywords(this.getKeywords);
                        observer.disconnect();
                    }
                });
            },
            { threshold: 0.5 }
        );
        this.$nextTick(() => {
            observer.observe(this.$el);
        });
        $(document).on('video.play', (e, data) => {
            data && data.iframe && this.sendTrack(data.iframe);
        });
    },
    beforeUnmount() {
        if (window.players) {
            this.$el.querySelectorAll('.video').map((iframe) => {
                let id = iframe.id;
                window.players[id].destroy();
            });
        }
    },
};
